class Modal {
    conf;
    constructor() {
        this.conf = {};
        this.create();
    }

      create() {
          window.MaestroInstance.Store.loadAsync('tarot-config').then((e) => {
              this.conf = e;
              let elment = document.querySelector('#app-emi-tarot');
              let modal = document.createElement('div');
              modal.className = 'modal';
              let modalContent = document.createElement('div');
              modalContent.className = 'modal-content';
              let closeContainer = document.createElement('div');
              closeContainer.className = 'close-container';
              let closeBtn = document.createElement('button');
              let textContainer = document.createElement("div");
              let text = document.createElement("div");
              textContainer.style = "margin: 10px;"
              textContainer.appendChild(text);
              text.innerText = e.textModal ?? "Your card";
              closeBtn.className = 'close-btn-modal';
              closeBtn.innerText = e.btnTextModal ?? "Sign up"
              closeBtn.onclick = this.close;
              closeContainer.appendChild(textContainer);
              closeContainer.appendChild(closeBtn);
              modal.appendChild(modalContent);
              modalContent.appendChild(closeContainer);
              elment.appendChild(modal);
              modal.style.display = 'none';
          })

    }

    open(cb , isMobile = false) {
        let modal = document.querySelector(".modal");
        let modalContent = document.querySelector(".modal-content");
        if(isMobile) modalContent.style = "height:45%; width: 100%"
        let cardsSelected = !isMobile ? document.querySelectorAll(".tarot-scene--selected") : document.querySelectorAll('article[card-selected="true"]');;
        let cardsContainer = document.createElement('div');
        cardsContainer.className = 'cards-container';
        if (isMobile) cardsContainer.style = "min-height: 180px; padding-top: 0;"
        let closeContainer = document.querySelector('.close-container');
        let btn = document.querySelector(".close-btn-modal");
        btn.onclick = () => {
            cb();
            this.close();
        };
        modalContent.insertBefore(cardsContainer, closeContainer);
        cardsSelected.forEach((item) => {
            if (isMobile) {
                const index = parseInt(item.getAttribute('data-emi-carousel-index'));
                item.style.transform = "none";
                item.removeAttribute("data-emi-carousel-index");
                item.style.opacity = 1;
                item.classList.remove('carousel-card-selected');
                item.style.content = "none"
                item.removeAttribute('id');
                item.classList.remove('app-emi-carousel-card');
                item.style.height = "100%";
                item.style.width = "100%";
                item.style.backgroundImage = `url(${this.conf.originalDeck[index].source})`;
            }
            item.onclick = null;
            cardsContainer.onclick = null;
            cardsContainer.appendChild(item);
        })

        modal.style.display = "flex"
        setTimeout(() => {
            modalContent.classList.add('modal-open');
        }, 100);

    }

    close() {
        let elment = document.querySelector('#app-emi-tarot');
        let modal = document.querySelector('.modal');
        modal.style.display = 'none';
        elment.removeChild(modal);
    }

    recreate() {
        this.create();
    }
}

export const modal = new Modal();
